import { connect } from 'react-redux'

import BondsList from '../components/BondsList'
import { RootState } from '../types/index'
import { MT4Connector, BondConfigItem } from '@bdswiss/mt4-connector'
import { SelectBond, selectBond, ViewBondDetails, viewBondDetails } from '../actions/bondActions'
import { Action, Dispatch } from 'redux'

const mt4: MT4Connector = MT4Connector.Instance

export function mapStateToProps(rootState: RootState) {
  return {
    bonds: mt4.bonds,
    demo: rootState.appConfig.demo,
  }
}

export function mapDispatchToProps(dispatch: Dispatch<SelectBond | ViewBondDetails | Action>) {
  return {
    onSelectBond: (bond: BondConfigItem) => dispatch(selectBond(bond)),
    onViewBondDetails: (bond: BondConfigItem) => dispatch(viewBondDetails(bond)),
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(BondsList)
